import React, { useState, useEffect } from 'react';
import '../CSS/Testimony.css';
import { getApprovedTestimonies } from '../firebase/firestoreService';
import { Link } from 'react-router-dom';

const Testimony = () => {
  const [testimonies, setTestimonies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getApprovedTestimonies()
      .then(data => setTestimonies(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="ngt-page-banner">
        <h1>Student Testimonials</h1>
        <p>Hear from the students and families who have experienced NGT's transformative education</p>
      </div>
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Testimonials</li>
        </ol>
      </nav>
      <section style={{ padding: '4rem 0', background: 'var(--ngt-light)' }}>
        <div className="container">
          <h2 className="section-title">What Our Students Say</h2>
          <p className="section-subtitle">Real experiences from real students across all courses</p>
          {loading ? (
            <div className="ngt-spinner"></div>
          ) : testimonies.length === 0 ? (
            <p className="text-center" style={{ color: 'var(--ngt-grey)' }}>No testimonials yet. Be the first to share your experience!</p>
          ) : (
            <div className="row g-4">
              {testimonies.map((t, i) => (
                <div key={t.id || i} className="col-md-6 col-lg-4">
                  <div className="ngt-testimony-card h-100">
                    <div className="tc-quote"><i className="fas fa-quote-left"></i></div>
                    <p className="tc-message">"{t.message}"</p>
                    <div className="tc-footer">
                      <div className="tc-avatar"><i className="fas fa-user-circle"></i></div>
                      <div>
                        <div className="tc-name">{t.name}</div>
                        <div className="tc-meta">{t.course} {t.batch && `· Batch ${t.batch}`}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="text-center mt-5">
            <Link to="/writetestimony" className="btn-ngt-primary">
              <i className="fas fa-pen me-2"></i> Share Your Story
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimony;
